// @flow
import { createSelector } from "reselect";
import Moment from "moment";
import { view } from "ramda";

import { FORMATO_DATA_BANCO } from "../../model";

import { type State } from "../";
import { dataBaseLens } from "../lenses";

export const getDataBaseSelecionada: State => ?Moment = createSelector(
  view(dataBaseLens),
  data =>
    data && Moment(data, FORMATO_DATA_BANCO, true)
      ? Moment(data, FORMATO_DATA_BANCO, true)
      : null
);

export const getDataBaseSelecionadaAsString = (state: State): string =>
  view(dataBaseLens, state) || "";

export const getDataBaseFormatadaBanco = createSelector(
  getDataBaseSelecionada,
  data => (data ? data.format(FORMATO_DATA_BANCO) : null)
);
